export default __webpack_public_path__ + "static/media/pg-grey.49a4c69c.svg";